/* eslint-disable no-unused-vars */
import axios from "axios";
import { SetupInterceptors } from "@/config/setupInter";
import * as st from "../config/setting.js";

const baseURL = st.url_api;

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
});

SetupInterceptors(http);

export default http;
